class EnvironmentUtils {
  static SITE_URL =
    process.env.REACT_APP_SITE_URL || "https://toofareastbarber.com";
  static MAP_TOKEN = process.env.REACT_APP_MAP_TOKEN;
  static FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
  static FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  static FIREBASE_DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
  static FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  static FIREBASE_STORAGE_BUCKET =
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  static FIREBASE_MESSAGING_SENDER_ID =
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
  static FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
}

export default EnvironmentUtils;
